var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingsDocument = function SvgSettingsDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#settings-document_csvg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.57 20a1.727 1.727 0 0 1-1.728-1.727v-.078a1.425 1.425 0 0 0-.933-1.304 1.425 1.425 0 0 0-1.572.285l-.052.052a1.727 1.727 0 0 1-2.95-1.222 1.73 1.73 0 0 1 .506-1.222l.052-.052a1.425 1.425 0 0 0 .285-1.572 1.43 1.43 0 0 0-1.304-.864h-.147a1.727 1.727 0 0 1 0-3.454h.078a1.425 1.425 0 0 0 1.304-.933 1.425 1.425 0 0 0-.285-1.572l-.052-.052a1.727 1.727 0 1 1 2.444-2.444l.052.052a1.425 1.425 0 0 0 1.572.285h.07a1.43 1.43 0 0 0 .863-1.304v-.147a1.727 1.727 0 1 1 3.454 0v.078a1.43 1.43 0 0 0 .864 1.304 1.425 1.425 0 0 0 1.572-.285l.051-.052a1.73 1.73 0 1 1 2.445 2.444l-.052.052a1.425 1.425 0 0 0-.285 1.572v.07M19.5 13H16a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13v3.5H23"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "settings-document_csvg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSettingsDocument;